import { FieldSet, IDataTableColumn, Loading } from "nsitools-react";
import * as React from "react";
import { Link } from "react-router-dom";

import { HealthPackApi, HealthPackGridDto, HealthPackSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { SRSHCustomSelector, ICustomSelectorProps } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IBreedHealthPackSelectorProps
  extends Pick<ICustomSelectorProps<any>, "linkedIds" | "onLinkedIdsChanged"> {
  linkedIds;
  onLinkedIdsChanged;
  editMode;
  loading;
}

export const BreedHealthPackSelector: React.FunctionComponent<IBreedHealthPackSelectorProps> = ({
  linkedIds,
  onLinkedIdsChanged,
  editMode,
  loading,
}) => {
  const { t } = useTl();
  const api = useApiService(HealthPackApi);
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Code),
        fieldName: "healthPackCode",
        render: (row: HealthPackGridDto) => (
          <Link to={`${ERoutes.healthPack}/${row.healthPackId}/detail/view`} target="_blank">
            {row.healthPackCode}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.HealthPackGroup),
        fieldName: "healthPackGroupName",
      },

      {
        header: () => t(ETLCodes.Article),
        fieldName: "articleName",
        render: (row: HealthPackGridDto) => (
          <Link to={`${ERoutes.article}/${row.articleId}/detail/view`} target="_blank">
            {row.articleName}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Laboratory),
        fieldName: "lab",
      },
    ],
    [t]
  );

  const getHealthPacks = React.useCallback((sObj: any) => api.baseSearch(HealthPackSearch.fromJS({ ...sObj })), [api]);
  const getHealthPackIds = React.useCallback((sObj: any) => api.getIds(HealthPackSearch.fromJS({ ...sObj })), [api]);

  return (
    <Loading isLoading={loading}>
      <FieldSet title={t(ETLCodes.HealthPack)}>
        <SRSHCustomSelector
          linkedIds={linkedIds}
          columns={columns}
          onLinkedIdsChanged={onLinkedIdsChanged}
          idField="healthPackId"
          searchFunction={getHealthPacks}
          searchIdsFunc={getHealthPackIds}
          editMode={editMode}
          sortKeys={{ healthPackCode: "ASC" }}
        />
      </FieldSet>
    </Loading>

    //   <SRSHCustomSelector
    //     linkedIds={formik.values.healthResultIds}
    //     columns={columns}
    //     onLinkedIdsChanged={(newIds) => formik.setFieldValue("healthResultIds", newIds)}
    //     idField="healthResultId"
    //     searchFunction={getHealthPacks}
    //     searchIdsFunc={getHealthPackIds}
    //     editMode={true}
    //   />
  );
};
